<template>
  <img class="logo-text-img" :src="logoWithText" v-if="withText" />
  <img class="logo-img" :src="logo" v-else />
</template>

<script lang="ts">
import config from '@/config';

export default {
  props: [
    "withText",
  ],
  setup() {
    const { logo, logoWithText } = config;
    return { logo, logoWithText }
  }
}
</script>

<style scoped>
  .logo-img {
    height: 30px;
  }
  .logo-text-img {
    width: 100px;
  }
</style>